/* src/app/features/tarefas/operacao/tarefas-operacao.component.scss */
h5 {
  margin-bottom: 40px;
}
.col-auto {
  margin-top: 15px;
}
.alterarEstado {
  margin-top: 40px;
}
.btn.btn-light {
  margin-top: 4px;
}
.d-flex.title {
  padding-right: 800px;
  font-weight: bold;
}
.d-flex.title2 {
  padding-right: 756px;
  font-weight: bold;
}
.d-flex.title3 {
  padding-right: 888px;
  font-weight: bold;
}
.d-flex.title4 {
  padding-right: 478px;
  font-weight: bold;
}
.d-flex.title5 {
  padding-right: 744px;
  font-weight: bold;
}
.d-flex.title6 {
  padding-right: 620px;
  font-weight: bold;
}
.d-flex.title7 {
  padding-right: 715px;
  font-weight: bold;
}
.erro {
  color: red;
}
/*# sourceMappingURL=tarefas-operacao.component.css.map */
